/* src/app/setting/setting.component.css */
.setting-page {
  display: grid;
}
.settings-card {
  padding: 24px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 24px;
}
.card-header h2 {
  margin: 0 0 8px;
}
.card-header p {
  margin: 0;
  color: rgba(0, 0, 0, 0.6);
}
.settings-content {
  display: grid;
  gap: 24px;
}
.upload-section {
  display: grid;
  gap: 8px;
}
.upload-label {
  font-weight: 600;
}
.state-message {
  padding: 16px;
  border-radius: 8px;
  background: #f5f5f5;
}
.error-state {
  background: #fdecea;
  color: #b71c1c;
}
.company-settings-form {
  display: grid;
  gap: 24px;
}
.field-grid {
  display: grid;
  gap: 16px;
}
.two-column {
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}
.toggle-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px 24px;
}
.colors-grid {
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}
.color-field {
  display: grid;
  gap: 8px;
  font-size: 14px;
}
.color-input-row {
  display: grid;
  grid-template-columns: 56px 1fr;
  gap: 12px;
  align-items: center;
}
.color-input-row input[type=color] {
  width: 56px;
  height: 40px;
  border: 0;
  padding: 0;
  background: transparent;
}
.preview-card {
  border-radius: 12px;
  padding: 16px;
  min-height: 110px;
}
.preview-title {
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.7;
  margin-bottom: 8px;
}
.preview-message {
  white-space: pre-wrap;
  line-height: 1.5;
}
.actions-row {
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 767px) {
  .settings-card {
    padding: 16px;
  }
  .card-header {
    flex-direction: column;
  }
  .actions-row {
    justify-content: stretch;
  }
  .actions-row button {
    width: 100%;
  }
}
/*# sourceMappingURL=setting.component.css.map */
